import { render, staticRenderFns } from "./ScreeningGroupManage.vue?vue&type=template&id=4853d71e&"
import script from "./ScreeningGroupManage.vue?vue&type=script&lang=js&"
export * from "./ScreeningGroupManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports